import BaseService from './base.service';

/**
 * Service for handling metrics API requests
 */
class MetricsService extends BaseService {
  constructor() {
    super('/api/Metrics');
  }

  // Get all metrics - matches controller's GetAllMetrics endpoint
  async getAll() {
    try {
      const response = await this.get('');
      return response;
    } catch (error) {
      console.error('Error fetching all metrics:', error);
      throw error;
    }
  }
}

export default new MetricsService();